<template>
  <div class="container col-lg-8 col-sm-12 mb-10">
    <Permissioned section="workers.view" vertical>
      <div
        v-for="(section, index) in allSections"
        :permission="section.permission"
        :key="index"
      >
        <div v-if="hasContent(section.key)">
          <component
            :data-test="section.key"
            :is="section.component"
            :userData="currentWorker"
            v-bind="section.props"
          />
          <v-divider class="mt-4" />
        </div>
      </div>
    </Permissioned>
  </div>
</template>
<script>
import Applications from "@/views/workers/components/WorkerDetails/components/WorkerActivity/components/Applications";
import Interviews from "@/views/workers/components/WorkerDetails/components/WorkerActivity/components/Interviews";
import Offers from "@/views/workers/components/WorkerDetails/components/WorkerActivity/components/Offers";
import Conversations from "@/views/workers/components/WorkerDetails/components/WorkerActivity/components/Conversations";
import { PERMISSIONS } from "@/constants/workers";
import Permissioned from "@/components/common/Permissioned";
import { size } from "lodash";

const { ACTIVITY } = PERMISSIONS;

export default {
  name: "WorkerActivity",
  components: {
    Permissioned,
    Conversations
  },
  data() {
    return {
      allSections: [
        {
          component: Applications,
          permission: ACTIVITY.applications,
          key: "applications",
          props: {
            navigateToBookingCandidates: true
          }
        },
        {
          component: Interviews,
          permission: ACTIVITY.interviews,
          key: "interviewSlots"
        },
        {
          component: Offers,
          permission: ACTIVITY.offers,
          key: "offers"
        },
        {
          component: Conversations,
          permission: ACTIVITY.conversations,
          key: "conversations"
        }
      ]
    };
  },
  methods: {
    hasContent(key) {
      return size(this.currentWorker[key]);
    }
  },
  props: {
    currentWorker: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss"></style>
